import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'

export class SuccessDisplay extends React.Component {
  render() {
    const { message, onClose } = this.props
    if (message) {
      if (onClose) {
        return (
          <ReactBootstrap.Alert variant={'success'} dismissible>
            <p>{message}</p>
          </ReactBootstrap.Alert>
        )
      } else {
        return (
          <ReactBootstrap.Alert variant={'success'}>
            <p>{message}</p>
          </ReactBootstrap.Alert>
        )
      }
    } else {
      return <p></p>
    }
  }
}
